import { box, HandSvg, ln, mark, markFill, on, we, wp, type HandPart } from "./hand-icon";

/*
2026-10-24 の帯への追加。錠や盾を持つ印は今まで無かった (NAV_ICON_PATHS に無いことを確かめた)。
他の印と同じ原料 (box / mark / wp / on) だけで、閉じた南京錠を描いた。本体が黄、鍵穴は黒の点、
つると本体で 3 本 (5 本までの決まりの中)
*/

/*
  ボタンとヘッダーのメニューに添える小さな図記号 (2026-10-11 ユーザーの指示「人は文章なんて読まない。一瞬で理解させたい」)。
  描き方は hand-icon.tsx の「B 手の揺れの太線」(2026-10-12 オーナーが選んだ)。メニューの 6 つは、オーナーが見た見本の形そのまま。
  14〜20px で潰れないよう、1つの記号の線は 5 本まで
*/
const BOOK_L = "M12 6.9C10.1 5.2 7.1 4.5 2.8 4.8v13.8c4.4-.2 7.3.5 9.2 2.1z";
const BOOK_R = "M12 6.9c2.1-1.5 5.1-2.2 9.1-1.9v13.7c-4.2-.3-7.2.4-9.1 2";

export const NAV_ICON_PATHS = {
  // 無料30日チャレンジは「入口」。黄の扉と床、取っ手
  trial: [
    mark(
      wp([
        [6.4, 20.8, 0.3],
        [6.4, 3.2],
        [17.6, 3.2],
        [17.6, 20.8, 0.3],
      ]),
    ),
    ln(2.8, 20.8, 21.2, 20.8),
    on("M14.4 12.2h.01", 2.8),
  ],
  // 個別カウンセリングは、1対1で話す大きな吹き出し
  counseling: [
    mark(
      wp(
        [
          [3, 3.5],
          [21, 3.5],
          [21, 16.5],
          [10.5, 16.5, 0.6],
          [6, 20.8, 0.5],
          [6.6, 16.5, 0.6],
          [3, 16.5],
        ],
        { r: 2.5 },
      ),
    ),
    on("M8 10h.01M12 10h.01M16 10h.01", 2.8),
  ],
  // 学ぶ中身は、開いた教科書。左の頁だけ黄
  curriculum: [mark(BOOK_L), BOOK_R],
  // 作るものは、コードの括弧を載せたブラウザの窓
  projects: [
    markFill("M5 3.5h14c1.4 0 2.5 1.1 2.5 2.5v2.6h-19V6c0-1.4 1.1-2.5 2.5-2.5z"),
    box(2.5, 3.5, 19, 17),
    ln(2.5, 8.6, 21.5, 8.6),
    wp(
      [
        [9.4, 12],
        [6.9, 14.6],
        [9.4, 17.2],
      ],
      { closed: false, r: 0.8 },
    ),
    wp(
      [
        [14.6, 12],
        [17.1, 14.6],
        [14.6, 17.2],
      ],
      { closed: false, r: 0.8 },
    ),
  ],
  // 受講生の声は、人と黄の吹き出し
  voices: [
    we(7.6, 8.4, 3.2, 3.2),
    "M2.2 21c.3-3.7 2.5-5.8 5.4-5.8 3 0 5.2 2.1 5.5 5.8",
    mark(
      wp(
        [
          [14.6, 2.8],
          [21.6, 2.8],
          [21.6, 9.3],
          [18.6, 9.3, 0.4],
          [16, 12, 0.4],
          [16.4, 9.3, 0.4],
          [14.6, 9.3],
        ],
        { r: 1.6 },
      ),
    ),
  ],
  // 手に入るものは、リボンを掛けた贈り物。ふたが黄
  "what-you-get": [
    box(4.2, 12.6, 15.6, 8.4, 2),
    mark(box(2.6, 8.2, 18.8, 4.4, 1.4)),
    "M12 12.8v8",
    "M12 8C11.1 5.2 8.8 3.5 7.3 4.2c-1.5.7-1 3.3 4.7 3.8zM12 8c.9-2.8 3.2-4.5 4.7-3.8 1.5.7 1 3.3-4.7 3.8z",
  ],
  // 料金は、穴の空いた黄の値札
  cost: [
    mark(
      wp(
        [
          [3, 3],
          [11.6, 3],
          [21, 12.4],
          [12.4, 21],
          [3, 11.6],
        ],
        { r: 2.2 },
      ),
    ),
    on(we(7.5, 7.5, 1.5, 1.5), 2.2),
  ],
  // よくある質問は、問いと答えの吹き出し 2 つ。答えが黄
  faq: [
    wp(
      [
        [2.5, 2.8],
        [15.5, 2.8],
        [15.5, 11.6],
        [7.4, 11.6, 0.4],
        [4.3, 14.6, 0.4],
        [4.8, 11.6, 0.4],
        [2.5, 11.6],
      ],
      { r: 2.2 },
    ),
    mark(
      wp(
        [
          [8.8, 9.4],
          [21.5, 9.4],
          [21.5, 18.2],
          [19.6, 18.2, 0.4],
          [20, 21.4, 0.4],
          [16.4, 18.2, 0.4],
          [8.8, 18.2],
        ],
        { r: 2.2 },
      ),
    ),
  ],
  // セキュリティ学習は、閉じた南京錠。本体が黄、鍵穴は黒の点
  security: [
    wp(
      [
        [7.8, 11],
        [7.8, 7, 3],
        [16.2, 7, 3],
        [16.2, 11],
      ],
      { closed: false },
    ),
    mark(box(4.6, 11, 14.8, 9.4, 2.2)),
    on("M12 15.3h.01", 2.4),
  ],
} satisfies Record<string, HandPart[]>;

export type NavIconName = keyof typeof NAV_ICON_PATHS;

export function NavIcon({ name, size = 16, className = "" }: { name: NavIconName; size?: number; className?: string }) {
  return <HandSvg parts={NAV_ICON_PATHS[name]} className={`nav-ic ${className}`.trim()} size={size} />;
}

/* HOME_SECTIONS の id と同じ。ページ内の節の飛び先に付ける */
export function navIconForSection(id: string): NavIconName | null {
  return id in NAV_ICON_PATHS ? (id as NavIconName) : null;
}
